export default __webpack_public_path__ + "static/media/004-starfish.23ff5dd9.png";